import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import CalculatedField from './CalculatedField';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';

import './index.css';

export default (element) => {
  const field = JSON.parse(element.dataset.field);

  const root = createRoot(element);
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <CalculatedField
        examType={element.dataset.examType}
        id={element.dataset.id}
        label={field.label}
        fieldsToCompute={field.fieldsToCompute}
        operation={field.operation}
        clinicalResults={field.clinicalResults}
        value={element.dataset.value}
        unit={field.unit}
      />
    </ErrorBoundary>,
  );
};
